import Logos from "../../lib/logos/logos.json" with { type: "json" };

interface LogoItem {
  width?: number;
  height?: number;
  url: string;
  alt: string;
}

export const LogoData = Logos as Record<string, LogoItem>;
